import { NgModule } from '@angular/core';
import { AddressPipe } from './address/address';
import { MomentPipe } from './moment/moment';
import { MoneyPipe } from './money/money';
import { TimePipe } from './time/time';
import { SafeUrlPipe } from './safe-url/safe-url';

@NgModule({
    declarations: [AddressPipe, MomentPipe, MoneyPipe, SafeUrlPipe, TimePipe],
    imports: [],
    exports: [AddressPipe, MomentPipe, MoneyPipe, SafeUrlPipe, TimePipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts